module.exports = __webpack_public_path__ + "files/638674ec4aa03fab617a27e0c919d916.png";